import React from 'react'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'
import styles from './side-bar.module.scss'
import { getLinkPath, logoutUser } from '../../utils'
import TextButton from '../TextButton'
import LogoutIcon from '../../assets/logout.svg'
import BackArrowIcon from '../../assets/back_arrow.svg'
import classNames from 'classnames'
import { useQuinceRouter as useRouter } from '@src/modules/navigation'
import useDeviceInfo from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { useTranslation } from 'next-i18next'
import { useCurrentUser } from '@lastbrand/fe-common/universal-auth'
import { useStatsigDynamicConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-config.hook'
import useRecurringItemSubscriptionsExperiment from '@src/quince-site-common/src/hooks/useRecurringItemSubscriptionsExperiment'
import { filteredMenuItems } from '@src/quince-site-common/src/utils/filtered-menu-items'
import { STATSIG_EXPERIMENTS } from '@src/config/statsig-experiments.config'

const SidebarNav = ({ menuList }) => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const isSubscriptionsEnabled = useRecurringItemSubscriptionsExperiment()
  const hiddenMenuItems = useStatsigDynamicConfig('hiddenMenuItems') ?? []

  const { isNativeView } = useDeviceInfo()
  const { user } = useCurrentUser()

  const filteredMenuList = filteredMenuItems(
    menuList || [],
    hiddenMenuItems.map(item => ({
      experimentName: STATSIG_EXPERIMENTS.RECURRING_ITEM_SUBSCRIPTIONS_ENABLED,
      experimentState: isSubscriptionsEnabled,
      ...item,
    })),
  )

  const handleChange = e => {
    const { value } = e.target
    if (value === 'logout') {
      logoutUser()
    } else router.push(value)
  }

  // remove query params from the active slug before comparison
  const activeSlug = router.asPath.split('?')[0]

  const accountMenuLink = '/account/menu'

  return (
    <div className={styles.container}>
      {!isNativeView && activeSlug !== accountMenuLink && (
        <div className={styles.mobileHeader}>
          <BackArrowIcon className={styles.backIcon} onClick={() => router.push(accountMenuLink)} />
        </div>
      )}
      <div className={styles.sticky}>
        <div className={styles.welcomeText}>
          {t('hi')} {t('var1_v1', { var1: user?.customerMetadata?.firstName || '' })}
        </div>
        <div className={styles.emailText}>{user?.email || ''}</div>
        <div className={styles.navWrapper}>
          <nav className={styles.nav}>
            {filteredMenuList.map(menuItem => {
              const isActive = activeSlug === getLinkPath(menuItem)
              return (
                <div key={menuItem.id} className={styles.navItem}>
                  {menuItem.logo && (
                    <img
                      src={menuItem.logo?.file?.url}
                      alt={menuItem.logo?.title || ''}
                      className={styles.navItemImage}
                      data-active={isActive}
                      onClick={() => router.push(getLinkPath(menuItem))}
                      // @i18n-ignore
                      role={'button'}
                    />
                  )}
                  <TextButton
                    className={classNames(styles.navItemLink, isActive && styles.navItemLinkActive)}
                    to={getLinkPath(menuItem)}
                  >
                    {menuItem.text}
                  </TextButton>
                </div>
              )
            })}
          </nav>
          <TextButton
            className={styles.logout}
            onClick={logoutUser}
            trackParams={{
              trackInternal: true,
              // @i18n-ignore
              category: 'login',
              action: 'account_logout',
              context: {
                login_email: user?.email,
                lb_user_id: getlbUserId(),
              },
            }}
          >
            <LogoutIcon alt={t('logout')} className={styles.logoutIcon} />
            {t('logout_v1')}
          </TextButton>
        </div>
      </div>
    </div>
  )
}

export default SidebarNav
